import { Download, HelpCircle, Play, Printer, Receipt } from "lucide-react";

export default function TdsReportsHeader({
  companyName,
  financialYear,
  payrollMonth,
  regimeLabel,
  lastGenerated,
  onGenerate,
  onExport,
  onPrint,
  onHelp,
  generating,
}) {
  return (
    <header className="tdsr-header">
      <div className="tdsr-header__main">
        <div className="tdsr-header__icon" aria-hidden="true">
          <Receipt size={22} />
        </div>
        <div className="tdsr-header__text">
          <h1 className="tdsr-header__title">TDS Reports</h1>
          <p className="tdsr-header__desc">
            Statutory tax reports — registers, projections, Form 16, and quarterly returns.
          </p>
          <dl className="tdsr-header__meta">
            <div>
              <dt>Company</dt>
              <dd>{companyName || "—"}</dd>
            </div>
            <div>
              <dt>Financial Year</dt>
              <dd>{financialYear ? `FY ${financialYear}` : "—"}</dd>
            </div>
            <div>
              <dt>Payroll Month</dt>
              <dd>{payrollMonth || "—"}</dd>
            </div>
            <div>
              <dt>Tax Regime</dt>
              <dd>{regimeLabel}</dd>
            </div>
            <div>
              <dt>Last Generated</dt>
              <dd>{lastGenerated?.at ? new Date(lastGenerated.at).toLocaleString() : "—"}</dd>
            </div>
            <div>
              <dt>Generated By</dt>
              <dd>{lastGenerated?.by || "—"}</dd>
            </div>
          </dl>
        </div>
      </div>
      <div className="tdsr-header__actions">
        <button
          type="button"
          className="tds-btn tds-btn--primary tds-btn--sm"
          onClick={onGenerate}
          disabled={generating}
        >
          <Play size={14} />
          Generate
        </button>
        <button type="button" className="tds-btn tds-btn--secondary tds-btn--sm" onClick={onExport}>
          <Download size={14} />
          Export
        </button>
        <button type="button" className="tds-btn tds-btn--secondary tds-btn--sm" onClick={onPrint}>
          <Printer size={14} />
          Print
        </button>
        <button type="button" className="tds-btn tds-btn--ghost tds-btn--sm" onClick={onHelp}>
          <HelpCircle size={14} />
          Help
        </button>
      </div>
    </header>
  );
}
